;var CreateCards = function( content, onClickCard ) {

  $.each( content, function( i ) {
    var image = '../assets/timeline/images/'+this.imagem;

    var card = $(
      '<div class="card ' + this.tipo + '" link="' + this.id + '" position="' + i + '">' +
        '<div class="header">' +
          '<div class="ano">' + this.ano + '</div>' +
          '<div class="nome">' + this.nome + '</div>' +
        '</div>' +
        '<div class="image" style="background-image:url(' + image + ')"></div>' +
        '<div class="opacity"></div>' +
      '</div>'
    ).on( 'click', onClickCard );

    this.dom = card;
    this.show = false;
    this.filtered = true;
  });

  return {
    'qtyCards': content.length,
    'content': content
  }

};
